import { CaretDownFilled } from "@ant-design/icons";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Popover } from "antd";
import { useRef, useState } from "react";

export const FilterPopover = ({ label, open, onOpenChange, items, onSelect, value }) => {
    const [search, setSearch] = useState("");
    const inputRef = useRef(null);

    const filteredItems = items.filter(item =>
        item.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Popover
            open={open}
            onOpenChange={(visible) => {
                onOpenChange(visible);
                if (!visible) setSearch("");
            }}
            afterOpenChange={(visible) => {
                if (visible) {
                    // Small delay ensures the popover content is fully rendered
                    setTimeout(() => inputRef.current?.focus(), 50);
                }
            }}
            overlayClassName="settingCustomPopover tableGridPopover"
            trigger="click"
            placement="bottom"
            content={
                <div>
                    <div className="popover-search">
                        <Input
                            ref={inputRef}
                            type="search"
                            name="popoverSearch"
                            style={{ width: "100%", backgroundColor: "white" }}
                            className="generic-input-control"
                            placeholder="Search..."
                            autoComplete="off"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            suffix={
                                <FontAwesomeIcon
                                    style={{ color: "#0091ae" }}
                                    icon={faSearch}
                                />
                            }
                        />
                    </div>
                    <div className="popover-data">
                        {filteredItems.length > 0 ? (
                            filteredItems.map((item) => (
                                <div
                                    key={item}
                                    className="popoverdataitem"
                                    onClick={() => onSelect?.(item)}
                                >
                                    {item}
                                </div>
                            ))
                        ) : (
                            <div className="popoverdataitem" style={{ color: "#999" }}>
                                No results found
                            </div>
                        )}
                    </div>
                </div>
            }
        >
            <div
                className={value ? "selectedText" : "grid-text-btn selectedTextpadding"}
                style={{ cursor: "pointer" }}
            >
                <span>
                    {value||label}
                    <CaretDownFilled style={{ color: "#0091ae", marginLeft: 6 }} />
                </span>
                {value && (
                    <FontAwesomeIcon
                        className="selectedTextCloseIcon"
                        icon={faClose}
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelect(null);
                        }}
                    />
                )}
            </div>
        </Popover>
    );
};